import { createFileRoute } from '@tanstack/react-router';
import {
  NewConnectionPage,
  assignLocation,
} from '../../../receptora/journey/new-connection-page.tsx';

export const Route = createFileRoute('/receptora/nova')({
  component: NewConnectionRoute,
});

function NewConnectionRoute(): JSX.Element {
  return <NewConnectionPage navigate={assignLocation} />;
}
